import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SuiContainer, SuiLabel, SuiTextInput } from '@splashthat/sui';
import styled from 'styled-components';

import SpacingStandardIcon from 'common/icons/SpacingStandard';
import SpacingTightIcon from 'common/icons/SpacingTight';
import SpacingLoosedIcon from 'common/icons/SpacingLoose';
import SettingsIcon from 'common/icons/Settings';
import {
    setStyleConfigurationFromPath,
    PATH_SPACING,
    PATH_SPACING_MODE,
    PATH_SPACING_LABEL_SEPARATION,
    PATH_SPACING_DATA_NODES_SEPARATION,
} from 'common/entities/form/styleConfiguration/actions';
import { getFormStyleProperty } from 'common/entities/form/styleConfiguration/selectors';
import { DEFAULT_SPACING } from 'common/entities/form/styleConfiguration/defaultValues';
import {
    SPACING_TIGHT,
    SPACING_STANDARD,
    SPACING_LOOSE,
    SPACING_CUSTOM,
    SPACING_DATA_NODES_SEPARATION,
    SPACING_DATA_LABEL_SEPARATION,
} from 'common/entities/form/styleConfiguration/constants';
import FormStyleTabsSelector from '../../FormStyleTabsSelector';
import { getFormId } from '../../../../selectors';
import { FORM_SIZE_SPACING } from '../../../../constants/formStyleLabels';

const LABEL_SEPARATION_LABEL = 'Labels';
const NODES_SEPARATION_LABEL = 'Questions';
const SEPARATION_LABEL_PLACEHOLDER = '0';

const StyledContainer = styled(SuiContainer)`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: space-around;
    margin-bottom: 10px;
`;

const StyledInput = styled(SuiTextInput)`
    margin: 0 1em;
`;

const SPACING_TABS = [
    {
        icon: SpacingTightIcon,
        label: 'Tight',
        value: SPACING_TIGHT,
    },
    {
        icon: SpacingStandardIcon,
        label: 'Standard',
        value: SPACING_STANDARD,
    },
    {
        icon: SpacingLoosedIcon,
        label: 'Loose',
        value: SPACING_LOOSE,
    },
    {
        icon: SettingsIcon,
        label: 'Custom',
        value: SPACING_CUSTOM,
    },
];

const MIN_SPACING = 0;
const MAX_SPACING = 200;

const SpacingSection = (props) => {
    const verifyInputRangeAndConfigurePath = (input, path) => {
        props.setStyleConfigurationFromPath(props.formId, path, Math.max(MIN_SPACING, Math.min(MAX_SPACING, input)));
    };
    return (
        <React.Fragment>
            <SuiLabel
                text={FORM_SIZE_SPACING}
                // data-qa={`${FORM_QA}--label`}
            />
            <FormStyleTabsSelector
                tabs={SPACING_TABS}
                value={props.mode}
                customName={SPACING_CUSTOM}
                onChange={(newMode) =>
                    newMode === SPACING_CUSTOM
                        ? props.setStyleConfigurationFromPath(props.formId, PATH_SPACING_MODE, newMode)
                        : props.setStyleConfigurationFromPath(props.formId, PATH_SPACING, DEFAULT_SPACING[newMode])
                }
            >
                <StyledContainer>
                    <StyledInput
                        fullWidth
                        placeholder={SEPARATION_LABEL_PLACEHOLDER}
                        label={LABEL_SEPARATION_LABEL}
                        type="number"
                        min={MIN_SPACING}
                        max={MAX_SPACING}
                        value={props.labelSeparation}
                        onChange={(_, value) => {
                            verifyInputRangeAndConfigurePath(value, PATH_SPACING_LABEL_SEPARATION);
                        }}
                    />
                    <StyledInput
                        fullWidth
                        placeholder={SEPARATION_LABEL_PLACEHOLDER}
                        label={NODES_SEPARATION_LABEL}
                        type="number"
                        min={MIN_SPACING}
                        max={MAX_SPACING}
                        value={props.nodesSeparation}
                        onChange={(_, value) => {
                            verifyInputRangeAndConfigurePath(value, PATH_SPACING_DATA_NODES_SEPARATION);
                        }}
                    />
                </StyledContainer>
            </FormStyleTabsSelector>
        </React.Fragment>
    );
};

SpacingSection.propTypes = {
    formId: PropTypes.string.isRequired,
    mode: PropTypes.string,
    labelSeparation: PropTypes.number,
    nodesSeparation: PropTypes.number,
    setStyleConfigurationFromPath: PropTypes.func.isRequired,
};

SpacingSection.defaultProps = {
    mode: SPACING_STANDARD,
    labelSeparation: DEFAULT_SPACING[SPACING_STANDARD][SPACING_DATA_LABEL_SEPARATION],
    nodesSeparation: DEFAULT_SPACING[SPACING_STANDARD][SPACING_DATA_NODES_SEPARATION],
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);

    return {
        formId,
        mode: getFormStyleProperty(state, formId, PATH_SPACING_MODE),
        labelSeparation: getFormStyleProperty(state, formId, PATH_SPACING_LABEL_SEPARATION),
        nodesSeparation: getFormStyleProperty(state, formId, PATH_SPACING_DATA_NODES_SEPARATION),
    };
};

const mapDispatchToProps = {
    setStyleConfigurationFromPath,
};

export default connect(mapStateToProps, mapDispatchToProps)(SpacingSection);
